import { FC } from 'react';

import Loader from 'components/Loader';
import ProcessCard, { ProcessCardConfig } from 'components/processes/ProcessCard';
import { useProcessStatusPolling } from 'components/processes/useProcessStatusPolling';

const WORDPRESS_CARD_CONFIG: ProcessCardConfig = {
    type: 'WORDPRESS_EMPLOYEE_SYNC',
    titleId: 'wordpress.title',
    descriptionId: 'wordpress.description',
    runButtonId: 'wordpress.sync',
    inProgressLabelId: 'wordpress.in-progress',
    progressMessageId: 'wordpress.in-progress',
    successChipLabelId: 'wordpress.success',
    successAlertId: 'wordpress.success',
    errorGeneralId: 'wordpress.error-general',
    errorAlreadyRunningId: 'wordpress.error-already-running',
    buttonVariant: 'outlined',
    buttonColor: 'primary',
};

const WordPressSync: FC = () => {
    const { statuses, isLoading: isLoadingStatuses } = useProcessStatusPolling();

    if (isLoadingStatuses) {
        return <Loader />;
    }

    return <ProcessCard config={WORDPRESS_CARD_CONFIG} isRunning={statuses?.WORDPRESS_EMPLOYEE_SYNC ?? false} />;
};

export default WordPressSync;
